import {
  SNAPSHIFT_CLIENT_ID,
  SNAPSHIFT_CLIENT_SECRET
} from '@libs/utils/environments'
import { useMutation } from '@tanstack/react-query'

import type { UseAppMutationOptions, ApiErrorResponse } from '../../../types'
import { postOauthToken } from '../auth.api'
import { authCacheKeys } from '../auth.cacheKeys'
import type { PostOauthResponse } from '../types/Oauth.post'

export type MutationOptionPostOauthRefreshToken = UseAppMutationOptions<
  PostOauthResponse,
  ApiErrorResponse,
  void
>

export const usePostOauthRefreshToken = (
  mutationOptions?: MutationOptionPostOauthRefreshToken
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: authCacheKeys.postOauthToken(),
    mutationFn: () =>
      postOauthToken({
        payload: {
          grant_type: 'refresh_token',
          client_secret: SNAPSHIFT_CLIENT_SECRET,
          client_id: SNAPSHIFT_CLIENT_ID
        }
      }),

    onSuccess: (data, variables, ...args) => {
      if (mutationOptions?.onSuccess) {
        mutationOptions.onSuccess(data, variables, ...args)
      }
    }
  })
}
